<div mat-dialog-title class="dialog-header">
    <div>
        <h4 class="modal-title">Selecteer een project</h4>
    </div>
    <button aria-label="Close" class="close-button" mat-dialog-close="" tabindex="-1">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div mat-dialog-content class="modal-body">
    <mat-selection-list [multiple]="false" class="w-100">
        @for (project of projects; track project) {
            <mat-list-option (click)="create(project)">
                {{ project.name }}
            </mat-list-option>
        }
    </mat-selection-list>
</div>
<div mat-dialog-actions class="modal-footer justify-content-between">
    <button color="primary" mat-button mat-dialog-close type="button">Annuleren</button>
</div>
